<template>
  <div class="filters__dropdown" :class="{'is-open': isOpen}" v-click-outside="closeDropdown">
    <button class="filters__dropdown-title"
            aria-haspopup="true"
            :aria-controls="title"
            :aria-expanded="ariaExpanded"
            @click="toggleOpen">
      {{ title }}
    </button>
    <div class="filters__dropdown-content" :id="title">
      <!-- for each filter -->
      <div class="filters__dropdown-col" v-for="filter in filters">
        <span class="filters__dropdown-col-title" v-if=" filter.column">{{ filter.column }}</span>
        <ul class="filters__dropdown-list" v-for="(option, i) in filter.options">
          <!-- for each filter option -->
          <li class="filters__dropdown-item">
            <checkbox :name="option.name" :id="'checkbox-' + i | replaceSpacesWithHyphens | lowercase" :item="option" :dropdown="true"></checkbox>
            <!-- for each child in filter option -->
            <ul class="filters__dropdown-list" v-if="option.children">
              <li class="filters__dropdown-item" v-for="(child, j) in option.children">
                <checkbox :name="child.name" :id="'checkbox-' + j | replaceSpacesWithHyphens | lowercase" :item="child" :dropdown="true"></checkbox>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

  import Checkbox from "./Checkbox";
  import { mapGetters } from 'vuex'

  export default {
    name: 'FilterDropdown',
    components: {
      Checkbox
    },
    props: {
      title: String,
      filters: Array
    },
    computed: {
      ...mapGetters({
        openDropdown: 'getOpenDropdown'
      }),
      isOpen() {
        return this.openDropdown === this.title
      },
      ariaExpanded() {
        return this.isOpen ? 'true' : 'false'
      },
    },
    methods: {
      toggleOpen() {
        if(this.isOpen === false) {
          this.$store.commit('updateOpenDropdown', this.title)
        } else {
          this.$store.commit('updateOpenDropdown', null)
        }

      },
      closeDropdown() {
        if(this.isOpen === true) {
          this.$store.commit('updateOpenDropdown', null)
        }
      }
    }
  }

</script>

<style>
  .filters__dropdown-list:not(:last-child) {
    margin-bottom: 15px;
  }
</style>